<template>
  <div class="RiwayatTraining">
    <SOSlotBase
      :container-name="`trainingDetail`"
      :loading="isLoading"
      :bg-grey="true"
      :is-search="onSearch"
    >
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Riwayat Training'"
          :type="'back'"
          :show-search="true"
          @search="searchButton"
          v-if="!onSearch"
          @back="back"
        />
      </template>

      <template v-slot:search-bar>
        <SOSearchBar
          v-if="onSearch"
          :context="'Anda bisa mencari:'"
          :placeholder="'ketik minimal 2 karakter'"
          :search-information="`Nama Training, ID Training, Status`"
          :value="key"
          :data-count="countDataSearch"
          :waiting="wait"
          @do-search="doSearch"
          @loading="onLoadingSearch"
          @close="onCloseSearch"
        />
      </template>

      <template v-slot:empty-state>
        <div>
          <SOEmptySearchState
            v-if="!countDataSearch && onSearch"
            @action="resetSearch"
          />

          <SOEmptyState
            v-if="!onSearch && dataListTraining.length < 1"
            :message="'Belum ada data training yang tersedia'"
          />
        </div>
      </template>
      <template v-slot:loading-page>
        <div>
          <SOLoadingPage />
        </div>
      </template>

      <template v-slot:content>
        <br />
        <div class="p-x-20">
          <p class="f-16 f-Overpass f-c-midgrey">
            Total {{ dataListTraining.length }} Training
          </p>
        </div>
        <div class="p-x-20">
          <template v-for="(data, index) in dataListTraining">
            <ListTraining
              :id_Training="data.id"
              :status_Training="data.status_training"
              :jenis_Training="data.training_jenis.nama"
              :jadwal_Training="
                data.training_detail[0] != null
                  ? $moment(
                      data.training_detail[0].jadwal_training_mulai
                    ).format('DD MMMM YYYY HH:mm')
                  : ''
              "
              :jadwal_Training_2="
                data.training_detail.length > 1
                  ? $moment(
                      data.training_detail[1].jadwal_training_mulai
                    ).format('DD MMMM YYYY HH:mm')
                  : ''
              "
              :batas_pembayaran="
                data.status_training == '60_menunggu_pembayaran'
                  ? data.training_pembayaran.expired_at
                  : ''
              "
              :key="index"
            />
          </template>
          <SOLoadMoreLoading
            v-if="dataListTraining.length >= pagination.offset"
            :id="'load-more-riwayat-training'"
            :loading="dataListTraining.length >= pagination.offset"
            @intersect="!isLoadingMore && loadData()"
          />
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import ListTraining from "../components/ListTraining.vue";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage.vue";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState.vue";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState.vue";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading.vue";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "RiwayatList",
  components: {
    SOSlotBase,
    SOTitleBar,
    ListTraining,
    SOSearchBar,
    SOLoadingPage,
    SOEmptySearchState,
    SOEmptyState,
    SOLoadMoreLoading,
  },

  data() {
    return {
      isLoading: false,
      isLoadingMore: false,
      onSearch: false,
      key: "",
      wait: false,
    };
  },

  async mounted() {
    await this.init();
  },

  computed: {
    ...mapGetters(moduleName, {
      dataListTraining: "dataListTraining",
      dataDetailPembayaran: "dataDetailPembayaran",
      pagination: "pagination",
      lastItemToView: "lastItemToView",
    }),

    countDataSearch() {
      return this.dataListTraining.length;
    },
  },

  methods: {
    ...mapActions({
      getDataListTraining: `${moduleName}/getDataListTraining`,
      getDataDetailPembayaran: `${moduleName}/getDataDetailPembayaran`,
      resetPagination: `${moduleName}/resetPagination`,
      resetDataList: `${moduleName}/resetDataList`,
    }),

    async init() {
      this.isLoading = true;
      await this.resetPagination();
      await this.resetDataList();
      let data = {
        paramSearch: "",
        offset: this.pagination.offset,
        limit: this.pagination.limit,
      };
      let res = await this.getDataListTraining(data);
      if (res) {
        this.isLoading = false;
      }
    },

    async doSearch(key) {
      this.key = key;
      await this.onLoadingSearch(false);
      await this.resetPagination();
      await this.resetDataList();
    },

    async loadData() {
      let data = {
        paramSearch: this.key,
        offset: this.pagination.offset,
        limit: this.pagination.limit,
      };
      await this.getDataListTraining(data);
    },

    onLoadingSearch(value) {
      this.wait = value;
    },

    resetSearch() {
      this.key = "";
    },

    back() {
      this.$router.go(-1);
    },

    toogleSearch(bool) {
      this.onSearch = bool;
    },

    async searchButton() {
      this.toogleSearch(true);
      await this.resetDataList();
      await this.resetPagination();
    },

    async onCloseSearch() {
      this.toogleSearch(false);
      await this.resetPagination();
      await this.resetDataList();
      this.key = "";
    },
  },
};
</script>
